import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import VastuLensLogo from './VastuLensLogo';
import styles from './Navbar.module.css';

const ScalesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2l-7 20h14l-7-20z" />
    <path d="M12 2v20" />
    <path d="M5.5 16h13" />
  </svg>
);

function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  return (
    <header className={styles.navbar}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <Link to="/" style={{ textDecoration: 'none' }} onClick={closeMobile}>
            <VastuLensLogo height={40} color="var(--color-primary)" />
          </Link>
        </div>

        {/* Desktop + mobile nav links */}
        <nav className={`${styles.navContainer} ${mobileOpen ? styles.navOpen : ''}`}>
          <ul className={styles.navLinks}>
            <li>
              <NavLink
                to="/analysis"
                className={({ isActive }) => (isActive ? `${styles.link} ${styles.activeLink}` : styles.link)}
                onClick={closeMobile}
              >
                Plan Analysis
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/blog"
                className={({ isActive }) => (isActive ? `${styles.link} ${styles.activeLink}` : styles.link)}
                onClick={closeMobile}
              >
                Knowledge Base
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/business"
                className={({ isActive }) => (isActive ? `${styles.link} ${styles.activeLink}` : styles.link)}
                onClick={closeMobile}
              >
                For Business
              </NavLink>
            </li>
            {/* Mobile-only: Compare link inside menu */}
            <li className={styles.mobileOnly}>
              <NavLink
                to="/compare"
                className={({ isActive }) => (isActive ? `${styles.link} ${styles.activeLink}` : styles.link)}
                onClick={closeMobile}
              >
                Compare Properties
              </NavLink>
            </li>
          </ul>
        </nav>

        {/* Desktop-only: Compare pill */}
        <div className={styles.rightActions}>
          <NavLink to="/compare" className={`btn-pill ${styles.compareBtn}`}>
            <ScalesIcon />
            Compare Shortlist
          </NavLink>
        </div>

        {/* Hamburger toggle */}
        <button
          className={`${styles.hamburger} ${mobileOpen ? styles.hamburgerOpen : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile overlay backdrop */}
      {mobileOpen && <div className={styles.backdrop} onClick={closeMobile} />}
    </header>
  );
}

export default Navbar;
